// services to communicate with BE.

import { GRAPHQL_API_URL } from "config/config";
import CIQClient, { HTTPClientResponse } from "services/ciq-client";
import ErrorManager from "utils/cumulative-error-message/error-manager";
import { SentryErrorSources } from "constants/index";

export const getGQLQueryData = async (
  token: string,
  queryDefinition: string,
  variables?: any,
  signal?: AbortSignal
): Promise<HTTPClientResponse> => {
  if (!token) {
    return {
      success: false,
      errorMsg: "Token is required",
      response: null
    };
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    },
    signal
  };

  const postPayload: any = {
    url: GRAPHQL_API_URL,
    data: {
      query: `query ${queryDefinition}`
    },
    config
  };

  if (variables) {
    postPayload.data.variables = variables;
  }

  const response: HTTPClientResponse = await CIQClient.post(postPayload);

  // Below condition is needed because hasura returns error in response.data.errors and status code is always 200
  if (response?.data?.errors && response?.data?.errors.length > 0) {
    const errorMsg = ErrorManager().handleError({
      error: response.data.errors[0],
      errorSource: SentryErrorSources.graphql
    });
    return {
      success: false,
      error: response.data.errors,
      errorMsg,
      response
    };
  }

  return response;
};
